class MainProductInformation extends HTMLElement
{
    _params = {
        truncatewords: 2
    };

    _elements = [];

    connectedCallback()
    {
        const truncate = {
            container: this.querySelector('.main-product-information-description'),
            buttons: this.querySelectorAll('.main-product-information-description__button'),
        }

        truncate.buttons.forEach(button => 
            button.addEventListener('click', () => 
                truncate.container.classList.toggle('active')
            )
        )
    }
}

customElements.define('w-main-product-information', MainProductInformation)